import { Header } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledGridHeader = styled(Header)`
position: absolute;
top: 10px;
left: 10px;
font-size: 20px !important;
font-weight: bold !important:
`
export const ImageWithTextWrapper = styled.div`
display: flex;
align-items: center;
 .company-header {
  font-weight: bold;
 }
 .role-header {
  font-size: 13px !important;
 }
`